import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import { INotification } from "infrastructure/notification";
import { INotificationActionResult } from "infrastructure/store";
import { getScreenExtraReducers } from "ui/app";

import { IPlexTranslationUploadState, getInitialPlexTranslationUploadState, IPlexTranslationUploadError } from "./PlexTranslationUpload.state";

const initialState = getInitialPlexTranslationUploadState();

export const plexTranslationUploadManager = createSlice({
  name: "plexTranslationsUpload",
  initialState: initialState,
  reducers: {
    uploadPlexTranslation: (state: IPlexTranslationUploadState, _action: PayloadAction<File[]>) => {
      return {
        ...state,
        uploadProcessing: true,
        uploadCompleted: false,
        notifications: [],
        error: undefined,
        progress: 1
      };
    },
    uploadPlexTranslationProcessing: (state: IPlexTranslationUploadState, action: PayloadAction<number>) => {
      return {
        ...state,
        progress: action.payload
      };
    },
    resetUploadingPlexTranslation: () => {
      return initialState;
    },
    uploadPlexTranslationCompleted: (state: IPlexTranslationUploadState) => {
      return {
        ...state,
        uploadProcessing: false,
        uploadCompleted: true
      };
    },
    uploadPlexTranslationFailed: (state: IPlexTranslationUploadState, action: PayloadAction<INotificationActionResult<IPlexTranslationUploadError>>) => {
      return {
        ...state,
        progress: 0,
        uploadProcessing: false,
        uploadCompleted: true,
        notifications: action.payload.notification ? [action.payload.notification] : [],
        error: action.payload.data
      };
    },
    uploadPlexTranslationError: (state: IPlexTranslationUploadState, action: PayloadAction<INotification>) => {
      return { ...state, progress: 0, uploadProcessing: false, notifications: [action.payload] };
    }
  },
  extraReducers: getScreenExtraReducers<IPlexTranslationUploadState>("notifications", initialState)
});
